import { fromBase64Url } from './bytes.js';
import { coseToJwk } from './cose.js';
import { DOMAIN, hashCanonicalB64 } from './hash.js';
/** Build a pinned credential from the COSE public key stored by the Worker at registration. */
export function pinnedCredentialFromCose(credentialId, cose, meta = {}) {
    const bytes = typeof cose === 'string' ? fromBase64Url(cose) : cose;
    fromBase64Url(credentialId); // validate encoding
    const { jwk, alg } = coseToJwk(bytes);
    const out = {
        credentialId,
        publicKey: jwk,
        alg,
        addedAt: meta.addedAt ?? Date.now(),
    };
    if (meta.label !== undefined)
        out.label = meta.label;
    return out;
}
/**
 * Order-independent hash over a credential set (ids, algs and keys; labels excluded). Both the
 * daemon and the PWA derive the enrollment SAS from it, so a swapped key set changes the words.
 */
export async function credentialSetHash(credentials) {
    const items = credentials
        .map((c) => ({ alg: c.alg, credentialId: c.credentialId, publicKey: c.publicKey }))
        .sort((a, b) => a.credentialId < b.credentialId ? -1 : a.credentialId > b.credentialId ? 1 : 0);
    return hashCanonicalB64(DOMAIN.credentialSet, items);
}
//# sourceMappingURL=credentials.js.map